// extracted by mini-css-extract-plugin
export default {"logo":"hf-logo_logo_aYTer"};